import type { RequestExecute } from '../../../../api';
import getHelper from '../../../services/getHelper';

import type Invitation from '../types/Invitation';

/**
 * @desc Helper for invitations.
 */
class InvitationsHelper extends getHelper<Invitation>('/invitations/:id') {
  /**
   * @desc Resend given invitation
   * @param {Number} invitationId Id of the invitation to resend.
   * @return {Promise} The promise handling the request.
   * @example
   * const invitationId = 1234;
   * const response = await myClient.helpers.employer.invitations.resend(invitationId);
   */
  resend(invitationId: number): RequestExecute<Invitation> {
    const request = this.create<Invitation>({}, false);
    request.url += '/resend';
    request.setRouteParam('id', `${invitationId}`);

    return request.execute();
  }
}

export default InvitationsHelper;
